import { useCallback } from 'react';
import {
  isStandardMarkerVisualSettings,
  type MarkerEntityStyle,
} from '~/_shared/types/marker.types';
import type { MarkerSettings } from '~/_shared/types/markers/visualSettings.types';
import { useFileUrls } from '~/store/frontendState/fileUrls/fileUrls.selector';
import { useMarkerSets } from '~/store/frontendState/markerSets/markerSets.selectors';
import { useMapSettingsFileAttachmentsMapSelector } from '~/store/mapSettings/fileAttachments/fileAttachments.selectors';
import { useMapSettingsMarkersTextureAnchors } from '~/store/mapSettings/makersGeneral/mapSettingsMarkersGeneral.selectors';
import { getMarkerEntityStyle } from './markerEntityStyle.helpers';
import { getInitialMarker } from './markersVisualSettings.helpers';
import { DEFAULT_MARKER_STYLE_ID } from './markerVisualSettings.constants';

export const useGetMarkerEntityStyleFromMarkerSettings = () => {
  const markerSets = useMarkerSets();
  const files = useFileUrls();
  const fileAttachments = useMapSettingsFileAttachmentsMapSelector();
  const { getMarkerTextureAnchor } = useMapSettingsMarkersTextureAnchors();

  return useCallback((markerSettings: MarkerSettings): MarkerEntityStyle => {
    return getMarkerEntityStyle({
      fallbackMarkerSettings: getInitialMarker(
        markerSettings.marker && isStandardMarkerVisualSettings(markerSettings.marker)
          ? markerSettings.marker.styleId
          : DEFAULT_MARKER_STYLE_ID,
      ),
      fileAttachments,
      fileMap: files,
      getMarkerTextureAnchor,
      markerSets,
      markerSettings,
      noShadow: true,
      markerLabelsDisabled: true,
    });
  }, [fileAttachments, files, getMarkerTextureAnchor, markerSets]);
};
